(function () {
  "use strict";

  var TIMEZONE = "America/Los_Angeles";
  var TIMES = [
    { value: "10:00", label: "10:00 AM" },
    { value: "18:00", label: "6:00 PM" }
  ];
  var SERVICES = {
    fit: { name: "20-Minute Fit Call", price: 50, duration: "20 minutes" },
    coaching: { name: "Songwriting Session", price: 125, duration: "1 hour" },
    professional: { name: "Professional writing", price: 250, duration: "1 hour" }
  };

  function dateInLosAngeles() {
    var parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: TIMEZONE,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return values.year + "-" + values.month + "-" + values.day;
  }

  function dateFromKey(key) { return new Date(key + "T12:00:00Z"); }
  function keyFromDate(date) { return date.toISOString().slice(0, 10); }
  function addDays(key, amount) {
    var date = dateFromKey(key);
    date.setUTCDate(date.getUTCDate() + amount);
    return keyFromDate(date);
  }
  function isWeekend(key) {
    var day = dateFromKey(key).getUTCDay();
    return day === 0 || day === 6;
  }
  function firstWeekdayOnOrAfter(key) {
    var result = key;
    while (isWeekend(result)) result = addDays(result, 1);
    return result;
  }
  function monthStartFromKey(key) {
    var date = dateFromKey(key);
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1, 12));
  }
  function formatChosenDate(key) {
    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC"
    }).format(dateFromKey(key));
  }

  document.querySelectorAll("audio[data-song-audio]").forEach(function (player) {
    player.addEventListener("play", function () {
      document.querySelectorAll("audio[data-song-audio]").forEach(function (other) {
        if (other !== player) other.pause();
      });
    });
  });

  var root = document.querySelector("[data-booking-calendar]");
  if (!root) return;

  var today = dateInLosAngeles();
  var latest = addDays(today, 60);
  var monthStart = monthStartFromKey(today);

  var takenSlots = {};
  (root.dataset.takenSlots || "").split(",").forEach(function (entry) {
    var key = entry.trim();
    if (key) takenSlots[key] = true;
  });
  function isTaken(dateKey, timeValue) { return !!takenSlots[dateKey + "|" + timeValue]; }
  function openTimesFor(dateKey) {
    return TIMES.filter(function (time) { return !isTaken(dateKey, time.value); }).length;
  }
  function firstBookableWeekday(key) {
    var result = firstWeekdayOnOrAfter(key);
    while (openTimesFor(result) === 0 && result <= latest) result = firstWeekdayOnOrAfter(addDays(result, 1));
    return result;
  }

  var selectedDate = firstBookableWeekday(today);
  var selectedTime = "";
  var service = "coaching";

  var monthLabel = root.querySelector("[data-month-label]");
  var calendarGrid = root.querySelector("[data-calendar-grid]");
  var chosenDate = root.querySelector("[data-chosen-date]");
  var timeOptions = root.querySelector("[data-time-options]");
  var serviceSummary = root.querySelector("[data-service-summary]");
  var previousButton = root.querySelector("[data-previous-month]");
  var nextButton = root.querySelector("[data-next-month]");
  var form = root.querySelector("#booking-form");
  var error = root.querySelector("[data-booking-error]");
  var submitButton = root.querySelector("[data-submit-booking]");

  function currentService() { return SERVICES[service] || SERVICES.coaching; }

  function updateService() {
    root.querySelectorAll(".service-picker label").forEach(function (label) {
      var input = label.querySelector("input[type=radio]");
      label.classList.toggle("selected", input && input.checked);
    });
    var chosen = currentService();
    if (serviceSummary) serviceSummary.textContent = chosen.duration + " · $" + chosen.price;
    if (submitButton) submitButton.textContent = "Book this $" + chosen.price + " session";
    setHiddenValues();
  }

  function renderCalendar() {
    var year = monthStart.getUTCFullYear();
    var month = monthStart.getUTCMonth();
    var firstWeekday = monthStart.getUTCDay();
    var count = new Date(Date.UTC(year, month + 1, 0, 12)).getUTCDate();
    var currentMonth = monthStartFromKey(today);
    var latestMonth = monthStartFromKey(latest);

    monthLabel.textContent = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
      timeZone: "UTC"
    }).format(monthStart);
    previousButton.disabled = monthStart.getTime() <= currentMonth.getTime();
    nextButton.disabled = monthStart.getTime() >= latestMonth.getTime();
    calendarGrid.innerHTML = "";

    for (var blank = 0; blank < firstWeekday; blank += 1) {
      var spacer = document.createElement("span");
      spacer.className = "calendar-blank";
      calendarGrid.appendChild(spacer);
    }

    for (var day = 1; day <= count; day += 1) {
      var key = keyFromDate(new Date(Date.UTC(year, month, day, 12)));
      var weekend = isWeekend(key);
      var openCount = openTimesFor(key);
      var unavailable = key < today || key > latest || weekend || openCount === 0;
      var button = document.createElement("button");
      button.type = "button";
      button.className = "calendar-day" + (key === selectedDate ? " selected" : "");
      button.disabled = unavailable;
      button.setAttribute("aria-pressed", key === selectedDate ? "true" : "false");
      var statusLabel = key < today || key > latest ? "" : weekend ? "closed" : openCount === 0 ? "booked" : openCount + " open";
      button.innerHTML = "<b>" + day + "</b><small>" + statusLabel + "</small>";
      (function (dateKey) {
        button.addEventListener("click", function () {
          selectedDate = dateKey;
          selectedTime = "";
          clearError();
          renderCalendar();
          renderTimes();
        });
      })(key);
      calendarGrid.appendChild(button);
    }
  }

  function renderTimes() {
    chosenDate.textContent = formatChosenDate(selectedDate);
    timeOptions.innerHTML = "";
    TIMES.forEach(function (time) {
      var taken = isTaken(selectedDate, time.value);
      var button = document.createElement("button");
      button.type = "button";
      button.className = selectedTime === time.value ? "selected" : "";
      button.disabled = taken;
      button.innerHTML = time.label + "<small>" + (taken ? "Booked" : "Available") + "</small>";
      button.addEventListener("click", function () {
        if (taken) return;
        selectedTime = time.value;
        clearError();
        renderTimes();
        setHiddenValues();
      });
      timeOptions.appendChild(button);
    });
  }

  function clearError() {
    if (!error) return;
    error.hidden = true;
    error.textContent = "";
  }
  function showError(message) {
    if (!error) return;
    error.hidden = false;
    error.textContent = message;
  }
  function setHiddenValues() {
    if (!form) return;
    var chosen = currentService();
    var values = {
      "booking-service": chosen.name,
      "booking-price": "$" + chosen.price,
      "booking-date": selectedDate ? formatChosenDate(selectedDate) : "",
      "booking-time": TIMES.filter(function (item) { return item.value === selectedTime; }).map(function (item) { return item.label; })[0] || ""
    };
    Object.keys(values).forEach(function (id) {
      var field = form.querySelector("#" + id);
      if (field) field.value = values[id];
    });
  }

  root.querySelectorAll('input[name="service-choice"]').forEach(function (input) {
    input.addEventListener("change", function () {
      service = input.value;
      updateService();
    });
  });
  previousButton.addEventListener("click", function () {
    monthStart = new Date(Date.UTC(monthStart.getUTCFullYear(), monthStart.getUTCMonth() - 1, 1, 12));
    renderCalendar();
  });
  nextButton.addEventListener("click", function () {
    monthStart = new Date(Date.UTC(monthStart.getUTCFullYear(), monthStart.getUTCMonth() + 1, 1, 12));
    renderCalendar();
  });

  var VARIANT_IDS = {
    fit: root.dataset.fitVariant,
    coaching: root.dataset.coachingVariant,
    professional: root.dataset.professionalVariant
  };

  function addBookingToCart() {
    var variantId = VARIANT_IDS[service];

    if (!variantId) {
      showError("This session isn't connected to a product yet. Contact the site owner.");
      return;
    }

    var timeLabel = TIMES.filter(function (item) { return item.value === selectedTime; })[0].label;
    var nameField = form.querySelector('[name="properties[Name]"]');
    var emailField = form.querySelector('[name="properties[Email]"]');
    var goalsField = form.querySelector('[name="properties[Writing goals]"]');

    submitButton.disabled = true;
    submitButton.textContent = "Adding to cart…";

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {
            "Requested date": formatChosenDate(selectedDate),
            "Requested time": timeLabel + " Pacific Time",
            "_booking_date_key": selectedDate,
            "_booking_time_key": selectedTime,
            "Name": nameField ? nameField.value : "",
            "Email": emailField ? emailField.value : "",
            "Writing goals": (goalsField && goalsField.value) || "Not provided"
          }
        }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart-add-failed");
        return response.json();
      })
      .then(function () {
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "checkout";
      })
      .catch(function () {
        submitButton.disabled = false;
        submitButton.textContent = "Book this $" + currentService().price + " session";
        showError("We couldn't add that session to your cart. Please try again.");
      });
  }

  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!selectedTime) {
        showError("Choose a date and time first.");
        return;
      }
      if (isTaken(selectedDate, selectedTime)) {
        showError("That time was just booked. Please choose another.");
        selectedTime = "";
        renderTimes();
        return;
      }
      setHiddenValues();
      clearError();
      addBookingToCart();
    });
  }

  renderCalendar();
  renderTimes();
  updateService();
})();
